const identityTypes = {
    CUSTOMIZED_USER: 'CUSTOMIZED_USER',
    AUTH_CODE: 'AUTH_CODE',
    TT_USER: 'TT_USER',
    BC_AUTH_TT: 'BC_AUTH_TT',
};
const productSpecificTypes = {
    ALL: 'ALL',
    PRODUCT_SET: 'PRODUCT_SET',
    CUSTOMIZED_PRODUCTS: 'CUSTOMIZED_PRODUCTS',
};
const adSecondaryStatuses = {
    AD_STATUS_ALL: 'AD_STATUS_ALL',
    AD_STATUS_NOT_DELETE: 'AD_STATUS_NOT_DELETE',
    AD_STATUS_CAMPAIGN_DELETE: 'AD_STATUS_CAMPAIGN_DELETE',
    AD_STATUS_ADGROUP_DELETE: 'AD_STATUS_ADGROUP_DELETE',
    AD_STATUS_DELETE: 'AD_STATUS_DELETE',
    AD_STATUS_ADVERTISER_AUDIT_DENY: 'AD_STATUS_ADVERTISER_AUDIT_DENY',
    AD_STATUS_ADVERTISER_AUDIT: 'AD_STATUS_ADVERTISER_AUDIT',
    ADVERTISER_CONTRACT_PENDING: 'ADVERTISER_CONTRACT_PENDING',
    ADVERTISER_ACCOUNT_PUNISH: 'ADVERTISER_ACCOUNT_PUNISH',
    AD_STATUS_BALANCE_EXCEED: 'AD_STATUS_BALANCE_EXCEED',
    AD_STATUS_CAMPAIGN_EXCEED: 'AD_STATUS_CAMPAIGN_EXCEED',
    AD_STATUS_BUDGET_EXCEED: 'AD_STATUS_BUDGET_EXCEED',
    AD_STATUS_AD_PRE_ONLINE: 'AD_STATUS_AD_PRE_ONLINE',
    AD_STATUS_AUDIT: 'AD_STATUS_AUDIT',
    AD_STATUS_REAUDIT: 'AD_STATUS_REAUDIT',
    AD_STATUS_AUDIT_DENY: 'AD_STATUS_AUDIT_DENY',
    AD_STATUS_ADGROUP_AUDIT_DENY: 'AD_STATUS_ADGROUP_AUDIT_DENY',
    AD_STATUS_ADGROUP_PARTIAL_AUDIT_NO_DELIVERY: 'AD_STATUS_ADGROUP_PARTIAL_AUDIT_NO_DELIVERY',
    AD_STATUS_PARTIAL_AUDIT_DELIVERY_OK: 'AD_STATUS_PARTIAL_AUDIT_DELIVERY_OK',
    AD_STATUS_PARTIAL_AUDIT_NO_DELIVERY: 'AD_STATUS_PARTIAL_AUDIT_NO_DELIVERY',
    AD_STATUS_ADGROUP_INDUSTRY_QUALIFICATION_MISSING: 'AD_STATUS_ADGROUP_INDUSTRY_QUALIFICATION_MISSING',
    AD_STATUS_ADGROUP_INDUSTRY_QUALIFICATION_EXPIRED: 'AD_STATUS_ADGROUP_INDUSTRY_QUALIFICATION_EXPIRED',
    AD_STATUS_ADGROUP_INDUSTRY_QUALIFICATION_DENY: 'AD_STATUS_ADGROUP_INDUSTRY_QUALIFICATION_DENY',
    AD_STATUS_MUSIC_AUTHORIZATION_MISSING: 'AD_STATUS_MUSIC_AUTHORIZATION_MISSING',
    AD_STAUS_PIXEL_UNBIND: 'AD_STAUS_PIXEL_UNBIND',
    AD_STATUS_LIVE_OFFLINE: 'AD_STATUS_LIVE_OFFLINE',
    AD_STATUS_NOT_START: 'AD_STATUS_NOT_START',
    AD_STATUS_DONE: 'AD_STATUS_DONE',
    AD_STATUS_CAMPAIGN_DISABLE: 'AD_STATUS_CAMPAIGN_DISABLE',
    AD_STATUS_ADGROUP_DISABLE: 'AD_STATUS_ADGROUP_DISABLE',
    ADGROUP_STATUS_FROZEN: 'ADGROUP_STATUS_FROZEN',
    AD_STATUS_DISABLE: 'AD_STATUS_DISABLE',
    AD_STATUS_DELIVERY_OK: 'AD_STATUS_DELIVERY_OK',
    AD_STATUS_PROCESS_AUDIO: 'AD_STATUS_PROCESS_AUDIO',
    AD_STATUS_TRANSCODING_FAIL: 'AD_STATUS_TRANSCODING_FAIL',
    AD_STATUS_ADGROUP_ASSET_AUTHORIZATION_LOST: 'AD_STATUS_ADGROUP_ASSET_AUTHORIZATION_LOST',
    AD_STATUS_ASSET_AUTHORIZATION_LOST: 'AD_STATUS_ASSET_AUTHORIZATION_LOST',
    AD_STATUS_AD_QUOTA_LIMIT: 'AD_STATUS_AD_QUOTA_LIMIT',
    AD_STATUS_PRODUCT_UNAVAILABLE: 'AD_STATUS_PRODUCT_UNAVAILABLE',
    AD_STATUS_ANCHOR_UNAVAILABLE: 'AD_STATUS_ANCHOR_UNAVAILABLE',
    AD_STATUS_NO_AUTHORIZATION_OF_SHOWCASE: 'AD_STATUS_NO_AUTHORIZATION_OF_SHOWCASE',
    AD_STATUS_RF_ADGROUP_CLOSED: 'AD_STATUS_RF_ADGROUP_CLOSED',
    AD_STATUS_PROMOTE_AD_OFFLINE_AUDIT: 'AD_STATUS_PROMOTE_AD_OFFLINE_AUDIT',
    AD_STATUS_PROMOTE_ADGROUP_CLOSED: 'AD_STATUS_PROMOTE_ADGROUP_CLOSED',
};
const adFormats = {
    SINGLE_IMAGE: 'SINGLE_IMAGE',
    SINGLE_VIDEO: 'SINGLE_VIDEO',
    LIVE_CONTENT: 'LIVE_CONTENT',
    CAROUSEL_ADS: 'CAROUSEL_ADS',
    CATALOG_CAROUSEL: 'CATALOG_CAROUSEL',
};
const verticalVideoStrategies = {
    UNSET: 'UNSET',
    SINGLE_VIDEO: 'SINGLE_VIDEO',
    CATALOG_VIDEOS: 'CATALOG_VIDEOS',
    CATALOG_UPLOADED_VIDEOS: 'CATALOG_UPLOADED_VIDEOS',
    LIVE_STREAM: 'LIVE_STREAM',
};
const dynamicFormats = {
    UNSET: 'UNSET',
    DYNAMIC_CREATIVE: 'DYNAMIC_CREATIVE',
};
const itemStitchStatuses = {
    ENABLE: 'ENABLE',
    DISABLE: 'DISABLE',
};
const darkPostStatuses = {
    ON: 'ON',
    OFF: 'OFF',
};
const callToActions = {
    APPLY_NOW: 'APPLY_NOW',
    BOOK_NOW: 'BOOK_NOW',
    CALL_NOW: 'CALL_NOW',
    CONTACT_US: 'CONTACT_US',
    DOWNLOAD_NOW: 'DOWNLOAD_NOW',
    EXPERIENCE_NOW: 'EXPERIENCE_NOW',
    GET_QUOTE: 'GET_QUOTE',
    GET_SHOWTIMES: 'GET_SHOWTIMES',
    GET_TICKETS_NOW: 'GET_TICKETS_NOW',
    INSTALL_NOW: 'INSTALL_NOW',
    INTERESTED: 'INTERESTED',
    LEARN_MORE: 'LEARN_MORE',
    LISTEN_NOW: 'LISTEN_NOW',
    ORDER_NOW: 'ORDER_NOW',
    PLAY_GAME: 'PLAY_GAME',
    PREORDER_NOW: 'PREORDER_NOW',
    READ_MORE: 'READ_MORE',
    SEND_MESSAGE: 'SEND_MESSAGE',
    SHOP_NOW: 'SHOP_NOW',
    SIGN_UP: 'SIGN_UP',
    SUBSCRIBE: 'SUBSCRIBE',
    VIEW_NOW: 'VIEW_NOW',
    VIEW_PROFILE: 'VIEW_PROFILE',
    VISIT_STORE: 'VISIT_STORE',
    WATCH_LIVE: 'WATCH_LIVE',
    WATCH_NOW: 'WATCH_NOW',
    JOIN_THIS_HASHTAG: 'JOIN_THIS_HASHTAG',
    SHOOT_WITH_THIS_EFFECT: 'SHOOT_WITH_THIS_EFFECT',
    VIEW_VIDEO_WITH_THIS_EFFECT: 'VIEW_VIDEO_WITH_THIS_EFFECT',
};
const tikTokPageCategories = {
    PROFILE_PAGE: 'PROFILE_PAGE',
    OTHER_TIKTOK_PAGE: 'OTHER_TIKTOK_PAGE',
    TIKTOK_INSTANT_PAGE: 'TIKTOK_INSTANT_PAGE',
};
const deeplinkTypes = {
    UNIVERSAL_OR_APP: 'UNIVERSAL_OR_APP',
    SCHEME: 'SCHEME',
    NONE: 'NONE',
};
const shoppingAdsDeeplinkTypes = {
    NONE: 'NONE',
    CUSTOM: 'CUSTOM',
    SHOPPING_ADS: 'SHOPPING_ADS',
};
const shoppingAdsFallbackTypes = {
    DEFAULT: 'DEFAULT',
    CUSTOM: 'CUSTOM',
    SHOPPING_ADS: 'SHOPPING_ADS',
};
const fallbackTypes = {
    APP_INSTALL: 'APP_INSTALL',
    WEBSITE: 'WEBSITE',
    UNSET: 'UNSET',
};
const dynamicDestinations = {
    DLP: 'DLP',
    UNSET: 'UNSET',
};
const aigcDisclosureTypes = {
    SELF_DISCLOSURE: 'SELF_DISCLOSURE',
    NOT_DECLARED: 'NOT_DECLARED',
};
const disclaimerTypes = {
    TEXT_LINK: 'TEXT_LINK',
    TEXT_ONLY: 'TEXT_ONLY',
};
const viewabilityPostbidPartners = {
    UNSET: 'UNSET',
    MOAT: 'MOAT',
    DOUBLE_VERIFY: 'DOUBLE_VERIFY',
    IAS: 'IAS',
};
const brandSafetyPostbidPartners = {
    UNSET: 'UNSET',
    DOUBLE_VERIFY: 'DOUBLE_VERIFY',
    IAS: 'IAS',
    ZEFR: 'ZEFR',
};
const creativeTypes = {
    SHOP_PDP: 'SHOP_PDP',
    SHOP_PLP: 'SHOP_PLP',
    SHORT_VIDEO_LIVE: 'SHORT_VIDEO_LIVE',
    DIRECT_LIVE: 'DIRECT_LIVE',
    PSA: 'PSA',
    CUSTOM_INSTANT_PAGE: 'CUSTOM_INSTANT_PAGE',
};
const destinations = {
    APP: 'APP',
    TIKTOK_INSTANT_PAGE: 'TIKTOK_INSTANT_PAGE',
    WEBSITE: 'WEBSITE',
    SOCIAL_MEDIA_APP: 'SOCIAL_MEDIA_APP',
    PHONE_CALL: 'PHONE_CALL',
};
export const INSIGHTS_TIK_TOK_FILTERABLE_AD_ATTRIBUTES = {
    // advertiser_id: 'advertiser_id',
    // campaign_id: 'campaign_id',
    campaign_name: 'campaign_name',
    // campaign_system_origin: 'campaign_system_origin',
    // adgroup_id: 'adgroup_id',
    adgroup_name: 'adgroup_name',
    // ad_id: 'ad_id',
    ad_name: 'ad_name',
    // create_time: 'create_time',
    // modify_time: 'modify_time',
    // identity_id: 'identity_id',
    // identity_type: 'identity_type',
    // identity_authorized_bc_id: 'identity_authorized_bc_id',
    // catalog_id: 'catalog_id',
    // product_specific_type: 'product_specific_type',
    // item_group_ids: 'item_group_ids',
    // product_set_id: 'product_set_id',
    // sku_ids: 'sku_ids',
    // showcase_products: 'showcase_products',
    ad_format: 'ad_format',
    // vertical_video_strategy: 'vertical_video_strategy',
    // dynamic_format: 'dynamic_format',
    // video_id: 'video_id',
    // image_ids: 'image_ids',
    // carousel_image_index: 'carousel_image_index',
    // music_id: 'music_id',
    // tiktok_item_id: 'tiktok_item_id',
    // promotional_music_disabled: 'promotional_music_disabled',
    // item_duet_status: 'item_duet_status',
    // item_stitch_status: 'item_stitch_status',
    // dark_post_status: 'dark_post_status',
    // branded_content_disabled: 'branded_content_disabled',
    // shopping_ads_video_package_id: 'shopping_ads_video_package_id',
    // ad_text: 'ad_text',
    // ad_texts: 'ad_texts',
    // call_to_action: 'call_to_action',
    // call_to_action_id: 'call_to_action_id',
    // card_id: 'card_id',
    landing_page_url: 'landing_page_url',
    // utm_params: 'utm_params',
    // page_id: 'page_id',
    // cpp_url: 'cpp_url',
    // tiktok_page_category: 'tiktok_page_category',
    // phone_region_code: 'phone_region_code',
    // phone_region_calling_code: 'phone_region_calling_code',
    // phone_number: 'phone_number',
    // deeplink: 'deeplink',
    // deeplink_type: 'deeplink_type',
    // shopping_ads_deeplink_type: 'shopping_ads_deeplink_type',
    // deeplink_utm_params: 'deeplink_utm_params',
    // shopping_ads_fallback_type: 'shopping_ads_fallback_type',
    // fallback_type: 'fallback_type',
    // dynamic_destination: 'dynamic_destination',
    // aigc_disclosure_type: 'aigc_disclosure_type',
    // disclaimer_type: 'disclaimer_type',
    // disclaimer_text: 'disclaimer_text',
    // disclaimer_clickable_texts: 'disclaimer_clickable_texts',
    // tracking_pixel_id: 'tracking_pixel_id',
    // tracking_app_id: 'tracking_app_id',
    // tracking_offline_event_set_ids: 'tracking_offline_event_set_ids',
    // vast_moat_enabled: 'vast_moat_enabled',
    // viewability_postbid_partner: 'viewability_postbid_partner',
    // viewability_vast_url: 'viewability_vast_url',
    // brand_safety_postbid_partner: 'brand_safety_postbid_partner',
    // brand_safety_vast_url: 'brand_safety_vast_url',
    // impression_tracking_url: 'impression_tracking_url',
    // click_tracking_url: 'click_tracking_url',
    // playable_url: 'playable_url',
    // operation_status: 'operation_status',
    // secondary_status: 'secondary_status',
    // creative_type: 'creative_type',
    // app_name: 'app_name',
    // display_name: 'display_name',
    // avatar_icon_web_uri: 'avatar_icon_web_uri',
    // profile_image_uri: 'profile_image_uri',
    // creative_authorized: 'creative_authorized',
    // is_aco: 'is_aco',
    // is_new_structure: 'is_new_structure',
    // optimization_event: 'optimization_event',
};
//# sourceMappingURL=ad.js.map